import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import 'vuetify/dist/vuetify.min.css';
import { nl } from 'vuetify/locale';

import { aliases, md } from 'vuetify/iconsets/md';
import 'vuetify/styles';

const vuetify = createVuetify({
    components: {
        ...components
    },
    directives,
    icons: {
        defaultSet: 'md',
        aliases,
        sets: { md }
    },
    theme: {
        themes: {
            light: {
                dark: false,
                colors: { primary: '#3374eb', secondary: '#d8b13a', 'on-secondary': '#062558' }
            }
        },
        defaultTheme: 'light'
    },
    locale: {
        locale: 'nl',
        messages: { nl }
    },
    date: {
        locale: {
            nl: 'nl-NL'
        }
    },
    defaults: {
        VInput: {
            validateOn: 'submit'
        },
        VCardActions: {
            VBtn: { variant: 'flat' }
        },
        VBtn: {
            rounded: 'xl'
        },
        VCheckbox: {
            color: 'primary'
        }
    }
});

export default vuetify;
